import { useState, useEffect } from "react";
import emailjs from "emailjs-com";
import contactimg from "./image/services-details1.jpg";

function ContactUs() {
  const [statusMsg, setStatusMsg] = useState("");
  const [statusClass, setStatusClass] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  // Default recipient for outgoing emails (used as a fallback)
  const DEFAULT_TO_EMAIL = "sales@pranasrishti.com";

  // ✅ Initialize EmailJS once
  useEffect(() => {
    emailjs.init("a2O0zMhUg9URacF93"); // 👉 Your EmailJS Public Key
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;

    const formData = {
      from_name: form.name.value,
      from_email: form.email.value,
      // ensure template has recipient address expected by EmailJS templates
      to_email: DEFAULT_TO_EMAIL,
      address: form.address.value,
      mobile: form.mobile.value,
      service: form.service.value,
      message: form.message.value,
    };

    // Basic client-side validation: required fields
    if (!formData.from_name || !formData.from_email || !formData.message) {
      setStatusMsg("Please fill in name, email and message before sending.");
      setStatusClass("error");
      return;
    }

    // Validate recipient and sender emails (simple regex)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.to_email || !emailRegex.test(formData.to_email)) {
      // fallback to DEFAULT_TO_EMAIL and notify in console
      console.warn("Recipient email was empty or invalid; using default:", DEFAULT_TO_EMAIL);
      formData.to_email = DEFAULT_TO_EMAIL;
    }
    if (!emailRegex.test(formData.from_email)) {
      setStatusMsg("Please enter a valid sender email address.");
      setStatusClass("error");
      return;
    }

    // Helpful debug output before sending
    console.info("Sending email with template params:", formData);

    emailjs
      .send(
        "service_pztqrgw",         // 👉 Replace with your Zoho SMTP Service ID from EmailJS
        "template_ct1g858",   // 👉 Replace with your EmailJS Template ID
        formData,
        "a2O0zMhUg9URacF93"       // 👉 Your EmailJS Public Key
      )
      .then(
        () => {
          setStatusMsg("✅ Message sent successfully!");
          setStatusClass("success");
          form.reset();
          // Show success popup and auto-close after 2s
          setShowSuccessModal(true);
          setTimeout(() => setShowSuccessModal(false), 2000);
          // Send auto-reply to sender email (always send when sender email is present)
          if (formData.from_email) {
            // include multiple common keys (some templates use 'to' or 'to_email')
            const autoReplyParams = {
              to_name: formData.from_name || "",
              to_email: formData.from_email,
              email: formData.from_email,
              to: formData.from_email,
              reply_to: formData.from_email,
              message: `Hi ${formData.from_name || "there"},\n\nThanks for contacting us. We'll get back to you soon.\n\nRegards,\nPranasrishti`,
            };
            // Replace the template id below with the exact ID you created in EmailJS
            const autoReplyTemplateId = "template_mcb263f";
            const serviceId = "service_pztqrgw";
            const userId = "a2O0zMhUg9URacF93";

            console.info("Sending auto-reply with params:", autoReplyParams);
            emailjs
              .send(serviceId, autoReplyTemplateId, autoReplyParams, userId)
              .then((resp) => {
                console.info("Auto-reply success:", resp);
              })
              .catch((err) => {
                // Log full error for diagnosis
                console.error("Auto-reply failed:", err);
                const errText = (err && (err.text || err.status || err.message)) || JSON.stringify(err);
                console.warn("Auto-reply error text:", errText);
              });
          }
        },
        (error) => {
          // EmailJS returns an EmailJSResponseStatus object; log full details
          console.error("❌ Email send failed:", error);
          // Try to extract useful error text from known shapes
          const text =
            (error && (error.text || error.status || error.message)) ||
            JSON.stringify(error);
          setStatusMsg(`❌ Failed to send: ${text}`);
          setStatusClass("error");
        }
      );
  };

  return (
    <div>
      {/* Banner Section */}
      <div className="page-banner-area">
        <h2>Contact Us</h2>
        <p>Get in Touch with Us</p>
      </div>

      {/* Contact Us Form */}
      <div className="about-us-main-wrap">
        <div className="container">
          <div className="row">
            {/* Left Side Form */}
            <div className="col-lg-6">
              <div className="contact-container">
                <h2>Get in Touch</h2>
                <form id="contactForm" onSubmit={handleSubmit}>
                  <input type="text" name="name" placeholder="Your Name" required />
                  <input type="email" name="email" placeholder="Your Email" required />
                  <input type="text" name="address" placeholder="Your Address" required />
                  <input
                    type="tel"
                    name="mobile"
                    placeholder="Your Mobile Number"
                    required
                    pattern="[0-9]{10}"
                  />
                  <select name="service" required defaultValue="">
                    <option value="" disabled>
                      Choose a Service
                    </option>
                    <option>Web / WASA</option>
                    <option>Mobile - (Android/ios)</option>
                    <option>Networking/Infrastructure</option>
                    <option>Cloud</option>
                    <option>Configurations Review</option>
                    <option>IOT</option>
                    <option>OT</option>
                    <option>Red Teaming</option>
                    <option>SCA</option>
                    <option>API</option>
                    <option>Medical Device Security Testing</option>
                    <option>ISO</option>
                    <option>SOC</option>
                    <option>GDPR</option>
                    <option>Hippa</option>
                    <option>SAR DL</option>
                    <option>ASP esign</option>
                    <option>IS Audit</option>
                    <option>DPDP</option>
                  </select>
                  <textarea name="message" placeholder="Your Message" rows="5" required></textarea>
                  <button type="submit">Send</button>
                </form>

                {statusMsg && (
                  <div id="statusMsg" className={`status ${statusClass}`}>
                    {statusMsg}
                  </div>
                )}
                {/* Success Modal Popup */}
                {showSuccessModal && (
                  <div
                    role="dialog"
                    aria-modal="true"
                    aria-label="Message sent"
                    style={{
                      position: "fixed",
                      inset: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      background: "rgba(0,0,0,0.4)",
                      zIndex: 2000,
                    }}
                    onClick={() => setShowSuccessModal(false)}
                  >
                    <div
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        background: "#fff",
                        padding: "24px",
                        borderRadius: "8px",
                        maxWidth: "420px",
                        width: "90%",
                        boxShadow: "0 6px 30px rgba(0,0,0,0.25)",
                        textAlign: "center",
                      }}
                    >
                      <h3 style={{ marginTop: 0 }}>Message sent</h3>
                      <p>Your message was sent successfully. We'll contact you soon.</p>
                      <button
                        onClick={() => setShowSuccessModal(false)}
                        style={{
                          marginTop: "12px",
                          padding: "8px 16px",
                          borderRadius: "4px",
                          border: "none",
                          background: "#007bff",
                          color: "#fff",
                          cursor: "pointer",
                        }}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Right Side Image */}
            <div className="col-lg-6">
              <div className="about-usleft-content">
                <img src={contactimg} alt="Contact Us" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
